module.exports = __webpack_public_path__ + "static/media/ageas.0c07b343.webp";